import React from "react";
import ModalSideBar from "../../../../../components/ModalSideBar";
import AuditChangesList from "../../../../../components/AuditChangesList";
import { IHttpRequestQueue } from "../types/types";

// import { Container } from './styles';

interface Props {
  data?: IHttpRequestQueue;
  onClose: () => void;
  title: string;
}

const Info: React.FC<Props> = (props: Props) => {
  return (
    <ModalSideBar isOpen title={props.title} onClose={props.onClose}>
      <div className="w-full h-full">
        <AuditChangesList
          records={props.data ? [props.data] : []}
          statusContext={props.title}
        />
      </div>
    </ModalSideBar>
  );
};

export default Info;
